import { API } from '..';
import { DonateChallenge, ChallengeMode } from '../payment/donate-challenge.api';

// Admin quản lý "Sự kiện donate" — thử thách donate ở cấp toàn nền tảng (scope Platform),
// khác thử thách của từng creator (donate-challenge.api.ts). Cần quyền Donate.Manage +
// mã Authenticator cho mọi thao tác ghi (tạo/sửa/huỷ/trao lại quà).
const BASE = '/v1/payment-service/admin/donate-challenge';

export interface RewardInput {
  rankFrom: number;
  rankTo: number;
  storeItemCode?: string | null;
  durationDays?: number | null;
  minedCa?: number | null;
}

export interface SavePlatformChallengeBody {
  title: string;
  description?: string | null;
  mode: ChallengeMode;
  targetAmount?: number | null;
  winnerCount: number;
  startAt?: string | null;
  endAt: string;
  rewards: RewardInput[];
}

export const listDonateEvents = () => API.get<DonateChallenge[]>(BASE).then((r) => r.data);

export const getDonateEvent = (id: string) => API.get<DonateChallenge>(`${BASE}/${id}`).then((r) => r.data);

export const createDonateEvent = (body: SavePlatformChallengeBody, totpCode: string) =>
  API.post<DonateChallenge>(BASE, body, { params: { totpCode } }).then((r) => r.data);

export const updateDonateEvent = (id: string, body: SavePlatformChallengeBody, totpCode: string) =>
  API.put<DonateChallenge>(`${BASE}/${id}`, body, { params: { totpCode } }).then((r) => r.data);

export const cancelDonateEvent = (id: string, totpCode: string) =>
  API.post<DonateChallenge>(`${BASE}/${id}/cancel`, null, { params: { totpCode } }).then((r) => r.data);

export const retryDonateEventRewards = (id: string, totpCode: string) =>
  API.post<{ reset: number }>(`${BASE}/${id}/retry-rewards`, null, { params: { totpCode } }).then((r) => r.data);
